import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Le SEUL fil entre la fenêtre de bienvenue dessinée dans l'éditeur et le comportement qui la fait
 * marcher sur la vitrine (feature 0074, lot B).
 *
 * La section et ses blocs vivent dans `ui-react`, qui est partagé entre l'éditeur de thèmes et la
 * vitrine : ils ne peuvent rien importer de `apps/storefront` (l'inscription à la liste, la balise de
 * visite, la mémoire du navigateur). L'îlot de la vitrine, lui, est DANS la vitrine et a déjà tout cela,
 * testé. Il fournit donc le comportement par ce contexte, et la section ne connaît que trois choses : si
 * un envoi est en cours, s'il a échoué, et s'il a réussi.
 *
 * **Le défaut est INERTE, et ce n'est pas un repli : c'est le mode éditeur.** Sans fournisseur au-dessus,
 * le formulaire ne part nulle part et aucun blocage n'est possible — exactement ce qu'il faut dans le
 * canevas, où un envoi inscrirait la vendeuse à sa propre liste à chaque clic d'essai.
 */
import { createContext, useContext } from 'react';
const INERT = { phase: 'form', busy: false, error: null };
const WelcomeFormContext = createContext(INERT);
/** Branche le comportement de la vitrine sous la section. L'éditeur ne monte jamais ce fournisseur. */
export function WelcomeFormProvider({ value, children, }) {
    return _jsx(WelcomeFormContext.Provider, { value: value, children: children });
}
/** Ce que la section et ses blocs lisent. Ne lève jamais : sans fournisseur, tout est inerte. */
export function useWelcomeForm() {
    return useContext(WelcomeFormContext);
}
//# sourceMappingURL=welcomeForm.js.map